
import React, {useEffect, useState} from 'react';


import {
	createPayment_69fce3d85276935741630b32,
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';

import {
	addLoftyToken,
	deleteLoftytoken,
	set_lofty_global_carriton0fqi,
} from '../../actions/auth.actions';

import {customlistadoporcategorial1fxy_69e13dbdb08e22defc4dd913 } from '../../api/platillosghref.api'

import './menuppojl.scss';


const loftyShouldRenderCarousel = (products = []) => {
  const loftyIsMobile = window.innerWidth < 464;
  if (loftyIsMobile) {
    return true;
  }
  return products.length > 3;
}


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    



const lofty_value_default_caregoramngew_69cd791fb08e22defc4d8b41 = (param) => {
	if (param === 'principal') {
		return 'Platos principales / comida fuerte';
	}
	if (param === 'desayuno') {
		return 'Desayunos';
	}
	if (param === 'panaderia') {
		return 'Panadería';
	}
	if (param === 'postres') {
		return 'Postres';
	}
	if (param === 'bebidas') {
		return 'Bebidas';
	}
	if (param === 'cultural') {
		return 'Comida tradicional / cultural';
	}
	if (param === 'antojitos') {
		return 'Especialidades / antojitos';
	}
	return param;
}




const Pmenuppojl = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  lofty_global_carriton0fqi,
	set_lofty_global_carriton0fqi_app,

}) => {

	const [loftyres_69e13dbdb08e22defc4dd913_component_ih7d9b, setloftyres_69e13dbdb08e22defc4dd913_component_ih7d9b] = useState([]);
	const [loftyres_69e13dbdb08e22defc4dd913_component_iguof1, setloftyres_69e13dbdb08e22defc4dd913_component_iguof1] = useState([]);
	const [loftyres_69e13dbdb08e22defc4dd913_component_ipqnl6, setloftyres_69e13dbdb08e22defc4dd913_component_ipqnl6] = useState([]);
	const [loftyres_69e13dbdb08e22defc4dd913_component_i9go6w, setloftyres_69e13dbdb08e22defc4dd913_component_i9go6w] = useState([]);
	const [loftyres_69e13dbdb08e22defc4dd913_component_i0ma2y, setloftyres_69e13dbdb08e22defc4dd913_component_i0ma2y] = useState([]);
	const [loftyres_69e13dbdb08e22defc4dd913_component_inpwtf, setloftyres_69e13dbdb08e22defc4dd913_component_inpwtf] = useState([]);
	const [loftyres_69e13dbdb08e22defc4dd913_component_icq1ch, setloftyres_69e13dbdb08e22defc4dd913_component_icq1ch] = useState([]);


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadoporcategorial1fxy_69e13dbdb08e22defc4dd913({
					categorian0t6sg: `principal`,
				});
				setloftyres_69e13dbdb08e22defc4dd913_component_ih7d9b(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadoporcategorial1fxy_69e13dbdb08e22defc4dd913({
					categorian0t6sg: `desayuno`,
				});
				setloftyres_69e13dbdb08e22defc4dd913_component_iguof1(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadoporcategorial1fxy_69e13dbdb08e22defc4dd913({
					categorian0t6sg: `panaderia`,
				});
				setloftyres_69e13dbdb08e22defc4dd913_component_ipqnl6(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadoporcategorial1fxy_69e13dbdb08e22defc4dd913({
					categorian0t6sg: `postres`,
				});
				setloftyres_69e13dbdb08e22defc4dd913_component_i9go6w(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadoporcategorial1fxy_69e13dbdb08e22defc4dd913({
					categorian0t6sg: `bebidas`,
				});
				setloftyres_69e13dbdb08e22defc4dd913_component_i0ma2y(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadoporcategorial1fxy_69e13dbdb08e22defc4dd913({
					categorian0t6sg: `cultural`,
				});
				setloftyres_69e13dbdb08e22defc4dd913_component_inpwtf(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadoporcategorial1fxy_69e13dbdb08e22defc4dd913({
					categorian0t6sg: `antojitos`,
				});
				setloftyres_69e13dbdb08e22defc4dd913_component_icq1ch(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id69cd7ad0ee7dda37b6dc7a08" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <div id="itmdc" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngeoklb.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iacot" className="">
      
        <a
          target=""
          className=""
          id="i6edva"
          href="/"
        >
          
    <div id="iysqr8" className="">
    <>Inicio</>
      <br className="" id="" />
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iy44bl"
          href="/menu"
        >
          
    <div id="i41p5g" className="">
    <>Menú</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iyf8jb"
          href="/eventos"
        >
          
    <div id="iztdq8" className="">
    <>Reservaciones</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i377lh"
          href="/unite"
        >
          
    <div id="io6x2g" className="">
    <>Únete a nosotros</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i3knlt"
          href="/ubicaciones"
        >
          
    <div id="ie1esj" className="">
    <>Ubicaciones</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <div id="inff1e" className="">
      
        <a
          target=""
          className=""
          id="ijhswy"
          href="/carrito"
        >
          
    <div id="i7kn2y" className="">
    <>Carrito</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <img
        className=""
        id="iok6z3"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngeoklb.png"
        alt="undefined"
      />
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Menú</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Eventos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Únete a nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Ubicaciones</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Carrito</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ihk8" className="">
      
      <div id="iym0il" className="">
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        <>Nuestro Menú</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="i803s">
        <>Descubre los sabores auténticos de Honduras</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i3dh" className="">
      
      <div className="" id="iiaa8f">
        <>Platillos</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="ijh55q">
        <>Elige tu Antojo</>
      <br className="" id="" />
      
      </div>
      
      <div id="iiainz" className="">
      
      <div className="" id="ilhnie">
        <>Selecciona una categoría para ver todos los platillos disponibles. Cada uno preparado con ingredientes frescos y recetas tradicionales.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div className="" id="idrsbg">
        <>Platos principales / comida fuerte</>
      <br className="" id="" />
      
      </div>
      
        <div id="ih7d9b" className="">
        
            {
              loftyres_69e13dbdb08e22defc4dd913_component_ih7d9b?.map((loftyitem_69e13dbdb08e22defc4dd913_component_ih7d9b) => (
                <div key={loftyitem_69e13dbdb08e22defc4dd913_component_ih7d9b._id} className="" id="i4r09k">
                  
      <div id="icqlx4" className="">
      
      <div id="i26r94" className="">
      
        <img
          className=""
          id="ieepbh"
          alt=""
          src={loftyitem_69e13dbdb08e22defc4dd913_component_ih7d9b?.loftyUrl}
        />
        <>
        </>
      </div>
      
        <div className="" id="ix4wpe">
          
          <div className="" id="">
            {loftyitem_69e13dbdb08e22defc4dd913_component_ih7d9b?.nombrebt9uj}
          </div>
          
        </div>
        
        <div className="" id="i10l98">
          
          <div className="" id="">
            {loftyitem_69e13dbdb08e22defc4dd913_component_ih7d9b?.descripcin0j776}
          </div>
          
        </div>
        
      <div id="i5g57q" className="">
      
      <div id="i3pbpu" className="">
      
      <div className="" id="inrben">
        <>L</>
      </div>
      
        <div className="" id="ijsgut">
          
            <div className="" id="">
              {parseFloat(loftyitem_69e13dbdb08e22defc4dd913_component_ih7d9b?.preciofey2e)?.toLocaleString('en-US', {minimumFractionDigits: 2})}
            </div>
            
        </div>
        <>
        </>
      </div>
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        onClick={async () => {
		const newArrayState = lofty_global_carriton0fqi.map(o1 => o1);
		if (!newArrayState.find(o => o.cartitem._id === loftyitem_69e13dbdb08e22defc4dd913_component_ih7d9b._id)) {
			newArrayState.push({cartitem: loftyitem_69e13dbdb08e22defc4dd913_component_ih7d9b, quantity: 1});
			set_lofty_global_carriton0fqi_app(newArrayState);
			toastr.info('Se agrego exitosamente');
		}
}}

      >
      
      <div id="" className="">
      <>Agregar</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      <div className="" id="ih14y5">
        <>Desayunos</>
      </div>
      
        <div id="iguof1" className="">
        
            {
              loftyres_69e13dbdb08e22defc4dd913_component_iguof1?.map((loftyitem_69e13dbdb08e22defc4dd913_component_iguof1) => (
                <div key={loftyitem_69e13dbdb08e22defc4dd913_component_iguof1._id} className="" id="ivov6l">
                  
      <div id="idjc0z" className="">
      
      <div id="ir1qvf" className="">
      
        <img
          className=""
          id="i2p7d4"
          alt=""
          src={loftyitem_69e13dbdb08e22defc4dd913_component_iguof1?.loftyUrl}
        />
        <>
        </>
      </div>
      
        <div className="" id="iz4pcf">
          
          <div className="" id="">
            {loftyitem_69e13dbdb08e22defc4dd913_component_iguof1?.nombrebt9uj}
          </div>
          
        </div>
        
        <div className="" id="im0pyg">
          
          <div className="" id="">
            {loftyitem_69e13dbdb08e22defc4dd913_component_iguof1?.descripcin0j776}
          </div>
          
        </div>
        
      <div id="ik6v8e" className="">
      
      <div id="iwea98" className="">
      
      <div className="" id="i34ddr">
        <>L</>
      </div>
      
        <div className="" id="imyata">
          
            <div className="" id="">
              {parseFloat(loftyitem_69e13dbdb08e22defc4dd913_component_iguof1?.preciofey2e)?.toLocaleString('en-US', {minimumFractionDigits: 2})}
            </div>
            
        </div>
        <>
        </>
      </div>
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        onClick={async () => {
		const newArrayState = lofty_global_carriton0fqi.map(o1 => o1);
		if (!newArrayState.find(o => o.cartitem._id === loftyitem_69e13dbdb08e22defc4dd913_component_iguof1._id)) {
			newArrayState.push({cartitem: loftyitem_69e13dbdb08e22defc4dd913_component_iguof1, quantity: 1});
			set_lofty_global_carriton0fqi_app(newArrayState);
			toastr.info('Se agrego exitosamente');
		}
}}

      >
      
      <div id="" className="">
      <>Agregar</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      <div className="" id="ihk9g6">
        <>Panadería</>
      </div>
      
        <div id="ipqnl6" className="">
        
            {
              loftyres_69e13dbdb08e22defc4dd913_component_ipqnl6?.map((loftyitem_69e13dbdb08e22defc4dd913_component_ipqnl6) => (
                <div key={loftyitem_69e13dbdb08e22defc4dd913_component_ipqnl6._id} className="" id="ih9u21">
                  
      <div id="ilkeol" className="">
      
      <div id="i6cidk" className="">
      
        <img
          className=""
          id="inpsbi"
          alt=""
          src={loftyitem_69e13dbdb08e22defc4dd913_component_ipqnl6?.loftyUrl}
        />
        <>
        </>
      </div>
      
        <div className="" id="i7flp9">
          
          <div className="" id="">
            {loftyitem_69e13dbdb08e22defc4dd913_component_ipqnl6?.nombrebt9uj}
          </div>
          
        </div>
        
        <div className="" id="isg4c5">
          
          <div className="" id="">
            {loftyitem_69e13dbdb08e22defc4dd913_component_ipqnl6?.descripcin0j776}
          </div>
          
        </div>
        
      <div id="iwbnmf" className="">
      
      <div id="iz6g55" className="">
      
      <div className="" id="inkcvf">
        <>L</>
      </div>
      
        <div className="" id="i2cdz5">
          
            <div className="" id="">
              {parseFloat(loftyitem_69e13dbdb08e22defc4dd913_component_ipqnl6?.preciofey2e)?.toLocaleString('en-US', {minimumFractionDigits: 2})}
            </div>
            
        </div>
        <>
        </>
      </div>
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        onClick={async () => {
		const newArrayState = lofty_global_carriton0fqi.map(o1 => o1);
		if (!newArrayState.find(o => o.cartitem._id === loftyitem_69e13dbdb08e22defc4dd913_component_ipqnl6._id)) {
			newArrayState.push({cartitem: loftyitem_69e13dbdb08e22defc4dd913_component_ipqnl6, quantity: 1});
			set_lofty_global_carriton0fqi_app(newArrayState);
			toastr.info('Se agrego exitosamente');
		}
}}

      >
      
      <div id="" className="">
      <>Agregar</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      <div className="" id="ic2qe2">
        <>Postres</>
      </div>
      
        <div id="i9go6w" className="">
        
            {
              loftyres_69e13dbdb08e22defc4dd913_component_i9go6w?.map((loftyitem_69e13dbdb08e22defc4dd913_component_i9go6w) => (
                <div key={loftyitem_69e13dbdb08e22defc4dd913_component_i9go6w._id} className="" id="iuwrkl">
                  
      <div id="ipzvpe" className="">
      
      <div id="iibs1j" className="">
      
        <img
          className=""
          id="i2hbvx"
          alt=""
          src={loftyitem_69e13dbdb08e22defc4dd913_component_i9go6w?.loftyUrl}
        />
        <>
        </>
      </div>
      
        <div className="" id="iitwqd">
          
          <div className="" id="">
            {loftyitem_69e13dbdb08e22defc4dd913_component_i9go6w?.nombrebt9uj}
          </div>
          
        </div>
        
        <div className="" id="il07bv">
          
          <div className="" id="">
            {loftyitem_69e13dbdb08e22defc4dd913_component_i9go6w?.descripcin0j776}
          </div>
          
        </div>
        
      <div id="iaki7o" className="">
      
      <div id="ity32u" className="">
      
      <div className="" id="iwt62o">
        <>L</>
      </div>
      
        <div className="" id="inzb9x">
          
            <div className="" id="">
              {parseFloat(loftyitem_69e13dbdb08e22defc4dd913_component_i9go6w?.preciofey2e)?.toLocaleString('en-US', {minimumFractionDigits: 2})}
            </div>
            
        </div>
        <>
        </>
      </div>
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        onClick={async () => {
		const newArrayState = lofty_global_carriton0fqi.map(o1 => o1);
		if (!newArrayState.find(o => o.cartitem._id === loftyitem_69e13dbdb08e22defc4dd913_component_i9go6w._id)) {
			newArrayState.push({cartitem: loftyitem_69e13dbdb08e22defc4dd913_component_i9go6w, quantity: 1});
			set_lofty_global_carriton0fqi_app(newArrayState);
			toastr.info('Se agrego exitosamente');
		}
}}

      >
      
      <div id="" className="">
      <>Agregar</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      <div className="" id="iwy75l">
        <>Bebidas</>
      </div>
      
        <div id="i0ma2y" className="">
        
            {
              loftyres_69e13dbdb08e22defc4dd913_component_i0ma2y?.map((loftyitem_69e13dbdb08e22defc4dd913_component_i0ma2y) => (
                <div key={loftyitem_69e13dbdb08e22defc4dd913_component_i0ma2y._id} className="" id="iupibu">
                  
      <div id="iov2sc" className="">
      
      <div id="ipd3nx" className="">
      
        <img
          className=""
          id="imdthx"
          alt=""
          src={loftyitem_69e13dbdb08e22defc4dd913_component_i0ma2y?.loftyUrl}
        />
        <>
        </>
      </div>
      
        <div className="" id="iakfoo">
          
          <div className="" id="">
            {loftyitem_69e13dbdb08e22defc4dd913_component_i0ma2y?.nombrebt9uj}
          </div>
          
        </div>
        
        <div className="" id="ihkopy">
          
          <div className="" id="">
            {loftyitem_69e13dbdb08e22defc4dd913_component_i0ma2y?.descripcin0j776}
          </div>
          
        </div>
        
      <div id="if6zpm" className="">
      
      <div id="i5do0a" className="">
      
      <div className="" id="ixr9vq">
        <>L</>
      </div>
      
        <div className="" id="i56dor">
          
            <div className="" id="">
              {parseFloat(loftyitem_69e13dbdb08e22defc4dd913_component_i0ma2y?.preciofey2e)?.toLocaleString('en-US', {minimumFractionDigits: 2})}
            </div>
            
        </div>
        <>
        </>
      </div>
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        onClick={async () => {
		const newArrayState = lofty_global_carriton0fqi.map(o1 => o1);
		if (!newArrayState.find(o => o.cartitem._id === loftyitem_69e13dbdb08e22defc4dd913_component_i0ma2y._id)) {
			newArrayState.push({cartitem: loftyitem_69e13dbdb08e22defc4dd913_component_i0ma2y, quantity: 1});
			set_lofty_global_carriton0fqi_app(newArrayState);
			toastr.info('Se agrego exitosamente');
		}
}}

      >
      
      <div id="" className="">
      <>Agregar</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      <div className="" id="iuw9lm">
        <>Comida tradicional / cultural</>
      <br className="" id="" />
      
      </div>
      
        <div id="inpwtf" className="">
        
            {
              loftyres_69e13dbdb08e22defc4dd913_component_inpwtf?.map((loftyitem_69e13dbdb08e22defc4dd913_component_inpwtf) => (
                <div key={loftyitem_69e13dbdb08e22defc4dd913_component_inpwtf._id} className="" id="i4ksql">
                  
      <div id="i48yrb" className="">
      
      <div id="i3521m" className="">
      
        <img
          className=""
          id="iv0lwm"
          alt=""
          src={loftyitem_69e13dbdb08e22defc4dd913_component_inpwtf?.loftyUrl}
        />
        <>
        </>
      </div>
      
        <div className="" id="iafk7j">
          
          <div className="" id="">
            {loftyitem_69e13dbdb08e22defc4dd913_component_inpwtf?.nombrebt9uj}
          </div>
          
        </div>
        
        <div className="" id="ibrpll">
          
          <div className="" id="">
            {loftyitem_69e13dbdb08e22defc4dd913_component_inpwtf?.descripcin0j776}
          </div>
          
        </div>
        
      <div id="id9f19" className="">
      
      <div id="ibem97" className="">
      
      <div className="" id="iyvke3">
        <>L</>
      </div>
      
        <div className="" id="ipwaua">
          
            <div className="" id="">
              {parseFloat(loftyitem_69e13dbdb08e22defc4dd913_component_inpwtf?.preciofey2e)?.toLocaleString('en-US', {minimumFractionDigits: 2})}
            </div>
            
        </div>
        <>
        </>
      </div>
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        onClick={async () => {
		const newArrayState = lofty_global_carriton0fqi.map(o1 => o1);
		if (!newArrayState.find(o => o.cartitem._id === loftyitem_69e13dbdb08e22defc4dd913_component_inpwtf._id)) {
			newArrayState.push({cartitem: loftyitem_69e13dbdb08e22defc4dd913_component_inpwtf, quantity: 1});
			set_lofty_global_carriton0fqi_app(newArrayState);
			toastr.info('Se agrego exitosamente');
		}
}}

      >
      
      <div id="" className="">
      <>Agregar</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      <div className="" id="i2ih1i">
        <>Especialidades / antojitos</>
      <br className="" id="" />
      
      </div>
      
        <div id="icq1ch" className="">
        
            {
              loftyres_69e13dbdb08e22defc4dd913_component_icq1ch?.map((loftyitem_69e13dbdb08e22defc4dd913_component_icq1ch) => (
                <div key={loftyitem_69e13dbdb08e22defc4dd913_component_icq1ch._id} className="" id="i5va6z">
                  
      <div id="iw1lju" className="">
      
      <div id="i0z0lh" className="">
      
        <img
          className=""
          id="iws5sj"
          alt=""
          src={loftyitem_69e13dbdb08e22defc4dd913_component_icq1ch?.loftyUrl}
        />
        <>
        </>
      </div>
      
        <div className="" id="ifoni5">
          
          <div className="" id="">
            {loftyitem_69e13dbdb08e22defc4dd913_component_icq1ch?.nombrebt9uj}
          </div>
          
        </div>
        
        <div className="" id="i8nbxc">
          
          <div className="" id="">
            {loftyitem_69e13dbdb08e22defc4dd913_component_icq1ch?.descripcin0j776}
          </div>
          
        </div>
        
      <div id="iosc26" className="">
      
      <div id="i5h0n4" className="">
      
      <div className="" id="i1te1b">
        <>L</>
      </div>
      
        <div className="" id="iiqs6i">
          
            <div className="" id="">
              {parseFloat(loftyitem_69e13dbdb08e22defc4dd913_component_icq1ch?.preciofey2e)?.toLocaleString('en-US', {minimumFractionDigits: 2})}
            </div>
            
        </div>
        <>
        </>
      </div>
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        onClick={async () => {
		const newArrayState = lofty_global_carriton0fqi.map(o1 => o1);
		if (!newArrayState.find(o => o.cartitem._id === loftyitem_69e13dbdb08e22defc4dd913_component_icq1ch._id)) {
			newArrayState.push({cartitem: loftyitem_69e13dbdb08e22defc4dd913_component_icq1ch, quantity: 1});
			set_lofty_global_carriton0fqi_app(newArrayState);
			toastr.info('Se agrego exitosamente');
		}
}}

      >
      
      <div id="" className="">
      <>Agregar</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
                </div>
              ))
            }
            
        </div>
        <>
        </>
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <img
        className=""
        id="imi9j3"
        src="https://assetsprojects.s3.amazonaws.com/405gznimngeoklb.png"
        alt="undefined"
      />
      
      <div className="" id="iyo7r6">
        <>Sabores auténticos de Honduras. Tradición, calidad y amor en cada platillo.</>
      </div>
      <>
        </>
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Contacto</>
      </div>
      
      <div className="" id="i78qcc">
        <>+504 9999-9999</>
      </div>
      
      <div className="" id="il1rnw">
        <>info@correo.com</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iou1pv" className="">
      
      <div className="" id="izq2dp">
        <>Todos lo derechos reservados</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
	set_lofty_global_carriton0fqi_app: (value) => dispatch(set_lofty_global_carriton0fqi(value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pmenuppojl);
  